module.exports = __webpack_public_path__ + "img/search.8830b9ba.svg";